import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate() {
    window.location.assign(this.element.value)
  }
}
